import { FormControl, RadioGroup } from "@mui/material";
import React, { useState, useEffect } from "react";
import "./time-slot-widget.css";
import { useDispatch, useSelector } from "react-redux";
import { updateTimeSlot } from "../../features/timeSlotWidgetSlice";
import { Button } from "@mui/material";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "../../components/navigation/Nav-btn-group.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Loader from "../../components/loader/Loader";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ArrowBackOutlined } from "@mui/icons-material";

const TimeSlotWidget = () => {
  const dispatch = useDispatch();
  const { selectedDate } = useSelector((state) => state.calendarWidget);
  const [timeSlotList, setTimeSlotList] = useState([]);
  const [hospitalSlots, setHospitalSlots] = useState([]);
  const [mindtalkSlots, setMindtalkSlots] = useState([]);
  const [hyderabadSlots, setHyderabadSlots] = useState([]);

  const [timeSlot, setTimeSlot] = useState("");
  const [timeSlotID, setTimeSlotID] = useState(0);
  const [isSlotSelected, setIsSlotSelected] = useState(false);
  const [apiResponse, setApiResponse] = useState(0);
  const { doctorId, consultationMode } = useSelector(
    (state) => state.calendarWidget
  );
  const navigate = useNavigate();
  // console.log(doctorId);

  /**
   * @description convert date format from "Fri May 19 2023" to "2023-05-19" (yyyy-mm-dd)
   */
  const getFormattedDate = (dateStr) => {
    var date = new Date(dateStr);
    var startDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];
    var nextDate = date.setDate(date.getDate() + 1);
    var stopDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];

    return [startDate, stopDate];
  };

  useEffect(() => {
    fetchTimeSlots();
  }, []);

  const fetchTimeSlots = async () => {
    const oauthParams = {
      consumer_key: process.env.REACT_APP_CONSUMER_KEY,
      consumer_secret: process.env.REACT_APP_CONSUMER_SECRET,
      token: process.env.REACT_APP_TOKEN,
      token_secret: process.env.REACT_APP_TOKEN_SECRET,
      timestamp: Math.floor(Date.now() / 1000),
      nonce: Math.random().toString(36).substring(2),
    };

    const requestData = {
      url: `${
        process.env.REACT_APP_API_ENDPOINT
      }/restapi/1.0/object/slot.booking?domain=[('doctor_id','=',${doctorId}),('availability','=','open'),('start_datetime','>=','${
        getFormattedDate(selectedDate)[0]
      }'),('stop_datetime','<=','${
        getFormattedDate(selectedDate)[0]
      }')]&fields=['doctor_id','start_datetime','stop_datetime','id','campus_id']`,
      method: "get",
      params: {
        // your API parameters
      },
    };

    const signature = `${process.env.REACT_APP_CONSUMER_SECRET}&${process.env.REACT_APP_TOKEN_SECRET}`;
    const headers = {
      Authorization: `OAuth oauth_consumer_key="${
        process.env.REACT_APP_CONSUMER_KEY
      }", oauth_token="${
        process.env.REACT_APP_TOKEN
      }", oauth_signature_method="PLAINTEXT", oauth_timestamp="${
        oauthParams.timestamp
      }", oauth_nonce="${
        oauthParams.nonce
      }", oauth_version="1.0", oauth_signature="${encodeURIComponent(
        signature
      )}"`,
    };

    try {
      const response = await axios({
        url: requestData.url,
        method: requestData.method,
        headers,
        params: requestData.params,
      });
      if (response?.data) {
        setApiResponse(response?.status);
        let slotsData = response?.data;
        setTimeSlotList(slotsData["slot.booking"]);
        // console.log(response?.data["slot.booking"]);
        const hydSlots = response?.data["slot.booking"].filter(
          (slot) => slot.campus_id[0] === 5
        );
        // console.log("hyderabad: ", hydSlots);

        const mindSlots = response?.data["slot.booking"].filter(
          (slot) => slot.campus_id[0] === 4
        );
        // console.log("mindtalk: ", mindSlots);

        const hospSlots = response?.data["slot.booking"].filter(
          (slot) => slot.campus_id[0] === 1
        );
        // console.log("hospital: ", hospSlots);
        setHospitalSlots(hospSlots);
        setMindtalkSlots(mindSlots);
        setHyderabadSlots(hydSlots);
      }
    } catch (error) {
      // console.log(error);
      setApiResponse(404);
    }
  };

  const handleDataFromRadioBtn = async (data) => {
    // console.log(parseInt(data.id.split("-")[1]));
    await setTimeSlot(data?.value);
    await setTimeSlotID(Number(data?.id?.split("-")[1]));
    // console.log(
    //   data?.id?.split("-")[1],
    //   typeof Number(data?.id?.split("-")[1])
    // );
    navigate("/booking-details");
  };

  useEffect(() => {
    setIsSlotSelected(true);
    // console.log(timeSlotID);
    dispatch(updateTimeSlot({ timeSlot: timeSlot, timeSlotId: timeSlotID }));
  }, [timeSlot, timeSlotID, dispatch]);

  /**
   * @function convertUtcToIst()
   * @description function to convert the date-time string from UTC to IST
   * @param {*} utcString
   * @returns the slot date-time string converted to IST timezone in 24 hour format
   */
  const convertUtcToIst = (utcString) => {
    // Step 1: Parse the UTC date and time string
    const [datePart, timePart] = utcString.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hours, minutes, seconds] = timePart.split(":").map(Number);

    // Step 2: Create a Date object with the UTC date and time
    const utcDate = new Date(
      Date.UTC(year, month - 1, day, hours, minutes, seconds)
    );

    // Step 3: Convert the UTC date to IST by adding the time zone offset (UTC + 5 hours 30 minutes)
    const istOffset = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
    const localDate = new Date(utcDate.getTime() + istOffset);

    // Step 4: Return the converted local date as a string
    return localDate.toISOString();
  };

  return (
    <div className="time-slot">
      <Link to={"/booking-details"}>
        <Button variant="outlined" startIcon={<ArrowBackOutlined />}>
          back
        </Button>
      </Link>
      <h1>{selectedDate}</h1>
      {/* TODO: feature => campus and speciality filters */}
      <span className="time-slot-note">
        <InfoOutlinedIcon /> All the slot timings are in 24 hour format
      </span>
      {apiResponse === 200 ? (
        <div className="slot-wrapper">
          <FormControl sx={{ width: "100%" }}>
            {consultationMode === 2 ? (
              <RadioGroup
                defaultValue="9:00 AM"
                className="time-slots__container"
                name="radio-buttons-group"
              >
                {timeSlotList?.map((slot) => {
                  var slotStartDateTime = convertUtcToIst(slot?.start_datetime);
                  var slotStopDateTime = convertUtcToIst(slot?.stop_datetime);
                  return (
                    <TimeSlotSelectButton
                      key={slot.id}
                      startTime={slotStartDateTime?.split("T")[1].slice(0, 5)}
                      stopTime={slotStopDateTime?.split("T")[1].slice(0, 5)}
                      id={slot.id}
                      onData={handleDataFromRadioBtn}
                    />
                  );
                })}
              </RadioGroup>
            ) : (
              <div>
                <RadioGroup
                  defaultValue="9:00 AM"
                  className="time-slots__container"
                  name="radio-buttons-group"
                  sx={{
                    backgroundColor: "rgba(58, 132, 215, 0.24)",
                    padding: "16px",
                    display: hospitalSlots.length === 0 ? "none" : "flex",
                  }}
                >
                  <h2>Cadabams Hospital (JP Nagar, Bangalore)</h2>
                  {hospitalSlots?.map((slot) => {
                    var slotStartDateTime = convertUtcToIst(
                      slot?.start_datetime
                    );
                    var slotStopDateTime = convertUtcToIst(slot?.stop_datetime);
                    return (
                      <TimeSlotSelectButton
                        key={slot.id}
                        startTime={slotStartDateTime?.split("T")[1].slice(0, 5)}
                        stopTime={slotStopDateTime?.split("T")[1].slice(0, 5)}
                        id={slot.id}
                        onData={handleDataFromRadioBtn}
                      />
                    );
                  })}
                </RadioGroup>
                <RadioGroup
                  defaultValue="9:00 AM"
                  className="time-slots__container"
                  name="radio-buttons-group"
                  sx={{
                    backgroundColor: "rgba(93, 196, 141, 0.24)",
                    padding: "16px",
                    display: mindtalkSlots.length === 0 ? "none" : "flex",
                  }}
                >
                  <h2>Mindtalk (Indiranagar, Bangalore)</h2>
                  {mindtalkSlots?.map((slot) => {
                    var slotStartDateTime = convertUtcToIst(
                      slot?.start_datetime
                    );
                    var slotStopDateTime = convertUtcToIst(slot?.stop_datetime);
                    return (
                      <TimeSlotSelectButton
                        key={slot.id}
                        startTime={slotStartDateTime?.split("T")[1].slice(0, 5)}
                        stopTime={slotStopDateTime?.split("T")[1].slice(0, 5)}
                        id={slot.id}
                        onData={handleDataFromRadioBtn}
                      />
                    );
                  })}
                </RadioGroup>
                <RadioGroup
                  defaultValue="9:00 AM"
                  className="time-slots__container"
                  name="radio-buttons-group"
                  sx={{
                    backgroundColor: "rgba(245, 158, 11, 0.24)",
                    padding: "16px",
                    display: hyderabadSlots.length === 0 ? "none" : "flex",
                  }}
                >
                  <h2>Cadabams Hyderabad (Gachibowli)</h2>
                  {hyderabadSlots?.map((slot) => {
                    var slotStartDateTime = convertUtcToIst(
                      slot?.start_datetime
                    );
                    var slotStopDateTime = convertUtcToIst(slot?.stop_datetime);
                    return (
                      <TimeSlotSelectButton
                        key={slot.id}
                        startTime={slotStartDateTime?.split("T")[1].slice(0, 5)}
                        stopTime={slotStopDateTime?.split("T")[1].slice(0, 5)}
                        id={slot.id}
                        onData={handleDataFromRadioBtn}
                      />
                    );
                  })}
                </RadioGroup>
              </div>
            )}
          </FormControl>
        </div>
      ) : apiResponse === 404 ? (
        <EmptySlotsMessage />
      ) : (
        <Loader />
      )}
    </div>
  );
};

/**
 * @returns TimeSlotSelectButton
 */
const TimeSlotSelectButton = ({ id, startTime, stopTime, onData }) => {
  const [isSelected, setIsSelected] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [labelStyle, setLabelStyle] = useState({});

  useEffect(() => {
    const labelStyle = {
      padding: "12px",
      boxSizing: "border-box",
      width: "100%",
      display: "block",
      borderRadius: "100px",
      backgroundColor: isChecked ? `var(--white)` : `var(--white)`,
      border: isChecked ? `1px solid var(--grey)` : `1px solid var(--grey)`,
      color: isChecked ? `var(--apple-black)` : `var(--apple-black)`,
      fontSize: "20px",
      fontWeight: "bold",
      fontFamily: "var(--pp-telegraf)",
      transition: "all 0.3s ease-in-out",
      textAlign: "center",
    };

    setLabelStyle(labelStyle);
  }, [isChecked]);

  const handleChange = (e) => {
    // setIsChecked(e.target.checked);
    // console.log(e.target.value);
    onData(e.target);
  };

  return (
    <div className="time-slot-select">
      <label
        className="center-data"
        htmlFor={`radio-${id}`}
        // class={`time-slot-select__label time-slot-label-${key}`}
        style={labelStyle}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "5px",
            cursor: "pointer",
          }}
        >
          <input
            type="radio"
            className="myRadio"
            id={`radio-${id}`}
            onChange={handleChange}
            name="custom-radio"
            value={`${startTime} to ${stopTime}`}
            slotid={id}
          />
          <span>{`${startTime} to ${stopTime}`}</span>
        </div>
      </label>
    </div>
  );
};

/**
 *
 * @returns EmptySlotMessage component
 * @description empty state UI for the scenario where there are no available slots on a particular day
 */
const EmptySlotsMessage = () => {
  return (
    <div className="empty-slots-state">
      <h3>No Slots Available!</h3>
      <p>Please select another date or doctor for appointment</p>
    </div>
  );
};

export default TimeSlotWidget;
